const {LocalSettings} = require('./LocalSettings')
const {JustDate} = require('./JustDate')

/**
 * @param {number} monthsAgo
 * @return {Date}
 */
function lastMonth(monthsAgo=1) {
    const d = new Date()
    d.setMonth(d.getMonth() - monthsAgo)
    d.setDate(0)
    return new JustDate(d)
}

/**
 * @return {Date}
 */
function tommorow() {
    const d = new Date()
    d.setDate(d.getDate() + 1)
    return new JustDate(d)
}

/**
 * MinMax
 * Just holds min and max values
 */
class MinMax {
    /**
     * @param {int} min
     * @param {int} max
     */
    constructor(min=undefined, max=undefined) {
        this.min = min
        this.max = max
    }

    /**
     * @param {json} json
     * @return {MinMax}
     */
    static from(json) {
        return Object.assign(new MinMax(), json)
    }
}

/**
 * SearchModel
 * For searching quotes
 */
class SearchModel {
    /**
     * @param {string} givenId
     * @param {string} customerName
     * @param {string} jobName
     * @param {int} page
     * @param {int} pageCount
     * @param {MinMax} quoteDate
     * @param {string} orderBy
     * @param {string} givenIdSearchTerms
     * @param {bool} reverseOrder
     */
    constructor(givenId='', customerName='', jobName='',
        page=0, pageCount=null, quoteDate=new MinMax(undefined, undefined),
        orderBy='quote_date', givenIdSearchTerms='', reverseOrder=true) {
        this.given_id = givenId
        this.customer_name = customerName
        this.job_name = jobName
        this.page = page
        this.page_count = pageCount
        this.quote_date = quoteDate
        this.order_by = orderBy
        this.reverse_order = reverseOrder
        this.given_id_search_terms = givenIdSearchTerms

        if (this.page_count === null) {
            const localSettings = LocalSettings.fromStorage()
            this.page_count = localSettings.page_count
        }
    }

    /**
     * @param {json} json
     * @return {SearchModel}
     */
    static from(json) {
        return Object.assign(new SearchModel(), json)
    }

    /**
     * @return {SearchModel}
     */
    copy() {
        const model = SearchModel.from(this)
        model.quote_date =
            new MinMax(model.quote_date.min, model.quote_date.max)
        return model
    }
}

export {
    SearchModel,
}

